import usePageContext from '@rover/react-lib/src/context/usePageContext';
import { selectors as countryFooterLinksSelectors } from '@rover/react-lib/src/redux/ducks/countryFooterLinks.duck';
import { useApiCountryFooterLinksList } from '@rover/rsdk/src/apiClient/latest/api-country-footer-links-list';
import type { PaginatedCountryFooterLinkList } from '@rover/rsdk/src/apiClient/latest/model/paginatedCountryFooterLinkList';
import { getURL } from '@rover/shared/js/utils/getFullUrl';
import { getCountryUrlPrefix, US_COUNTRY_URL_PREFIX } from '@rover/utilities/roverGeo.constants';

import useDucks from './useDucks';

const selector = (state): PaginatedCountryFooterLinkList => ({
  count: 0,
  results: countryFooterLinksSelectors.getCountryFooterLinks(state),
});

const useCountryFooterLinksShim = (): PaginatedCountryFooterLinkList => {
  const { isReactQueryRoute } = usePageContext();
  const location = getURL();
  const countryUrlPrefix = getCountryUrlPrefix(location.pathname) ?? US_COUNTRY_URL_PREFIX;

  const { data: reactQueryData } = useApiCountryFooterLinksList(
    { countryUrlPrefix },
    {
      query: { enabled: isReactQueryRoute },
    }
  );

  const { data: selectedData } = useDucks({ selector });

  return isReactQueryRoute ? reactQueryData ?? { count: 0, results: [] } : selectedData;
};

export default useCountryFooterLinksShim;
